import { Skeleton } from '@mui/material'
import React from 'react'

const MapSkeletonWrapper = ({ emptyMaps, animation = false, errors, height = 192 }) =>
  [...Array(emptyMaps || 0).keys()].map((key) => (
    <Skeleton
      key={key}
      animation={animation}
      variant="rectangular"
      height={height}
      sx={{ borderRadius: '16px', border: !!errors?.favorite_map_ids ? '2px solid #FC5A5A' : 'none' }}
    />
  ))

export default MapSkeletonWrapper
